const Component = () => import('./Summary');

export { Component };
